// Commented out unused imports - may be needed in future
// import PermissionService from 'components/Common/PermissionService';
// import { productPerm } from 'utils/appConstants';
// import { snakeToDisplayString } from 'utils/jsUtils';

// A "status enum" to define our async states
export const ASYNC_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
};

export const F_PROVISION_LEVEL = {
  PLATFORM: 'PLATFORM',
  ACC: 'ACCOUNT',
  ORG: 'ORGANIZATION',
  CR: 'CLEAN_ROOM',
};

export const FLOW_STATUS = {
  DRAFT: { key: 'IS_DRAFT', value: 'Draft' },
  ACTIVE: { key: 'IS_ACTIVE', value: 'Active' },
  DEPRECATED: { key: 'IS_DEPRECATED', value: 'Deprecated' },
};

export const FLOW_TYPES = {
  ANALYTICS: { key: 'ANALYTICS', value: 'Analytics Flow', description: 'Data processing and analysis workflows.' },
  DATA_PIPELINE: { key: 'DATA_PIPELINE', value: 'Data Pipeline', description: 'Data transformation and movement workflows.' },
  ML_WORKFLOW: { key: 'ML_WORKFLOW', value: 'ML Workflow', description: 'Machine learning model training and inference workflows.' },
};

export const DISPLAY_F_STATUS = {
  IS_DRAFT: { key: 'IS_DRAFT', label: 'Draft' },
  IS_ACTIVE: { key: 'IS_ACTIVE', label: 'Active' },
  IS_DEPRECATED: { key: 'IS_DEPRECATED', label: 'Deprecated' },
};

export const FLOW_CATEGORIES = {
  ANALYTICS: { key: 'ANALYTICS', value: 'Analytics', description: 'Data analysis and reporting flows.' },
  ETL: { key: 'ETL', value: 'ETL', description: 'Extract, Transform, Load data processing flows.' },
  ML: { key: 'ML', value: 'Machine Learning', description: 'Machine learning and AI workflow flows.' },
};

export const DEFAULT_FLOW = {
  title: '',
  category: '',
  description: '',
  version: 1,
  status: FLOW_STATUS.DRAFT.key,
  tags: [],
  nodes: [],
  edges: [],
  parameters: [],
  settings: {},
};

export const EMPTY_FLOW = {
  title: '',
  category: '',
  description: '',
  version: 1,
  status: FLOW_STATUS.DRAFT.key,
  tags: [],
  nodes: [],
  edges: [],
  parameters: [],
  settings: {},
};

export const WIZARD_MODE = {
  CREATE: { key: 'CREATE', label: 'Create' },
  EDIT: { key: 'EDIT', label: 'Update' },
  CLONE: { key: 'CLONE', label: 'Clone' },
};

export const FLOW_NODE_TYPES = {
  QUESTION: { key: 'QUESTION', label: 'Question Node' },
  DATA_INPUT: { key: 'DATA_INPUT', label: 'Data Input' },
  DATA_OUTPUT: { key: 'DATA_OUTPUT', label: 'Data Output' },
  TRANSFORM: { key: 'TRANSFORM', label: 'Transform' },
  CONDITION: { key: 'CONDITION', label: 'Condition' },
};

export const VALIDATOR = {
  error: false,
  message: null,
};

export const FALLBACK_FLOW_VERSION = 1;

/**
 * React Query keys for flow-related queries
 * These constants ensure consistent query key usage across the codebase
 */
export const FLOW_QUERY_KEYS = {
  CR_FLOW_RUN: 'Cr-Flow-Run',
  FLOW_NODE_OUTPUTS: 'Flow-Node-Outputs',
  FETCH_NODE_DETAILS: 'Fetch-Node-Details',
  FLOW_NODE_RUN: 'Flow-Node-Run',
  FLOW_NODE_EXPORT_JOBS: 'Flow-Node-Export-Jobs',
  JOB_RUNS_BY_JOB_IDS: 'Job-Runs-By-Job-Ids',
};

/**
 * Flow run error messages
 */
export const FLOW_RUN_ERROR_MESSAGES = {
  FAILED_TO_RUN: 'Flow failed to run.',
};
